import { render, staticRenderFns } from "./fba-inventory.vue?vue&type=template&id=c50faa46&scoped=true&"
import script from "./fba-inventory.vue?vue&type=script&lang=js&"
export * from "./fba-inventory.vue?vue&type=script&lang=js&"
import style0 from "./fba-inventory.vue?vue&type=style&index=0&id=c50faa46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50faa46",
  null
  
)

export default component.exports